import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import * as React from 'react';
import { hasMissingChildValue, isElementSelected, sortChildrenBySelected, } from '../../helpers';
import InputLabel from '../InputLabel';
import InputHelperText from '../InputHelperText';
import withStyles from '../withStyles';
import styles from './MultiSelectField.styles';
import MultiSelectFieldOption from './MultiSelectFieldOption';
import MultiSelectFieldSearchBox from './MultiSelectFieldSearchBox';
export var MultiSelectFieldSortBy;
(function (MultiSelectFieldSortBy) {
    MultiSelectFieldSortBy["default"] = "default";
    MultiSelectFieldSortBy["label"] = "label";
    MultiSelectFieldSortBy["rightLabel"] = "rightLabel";
})(MultiSelectFieldSortBy || (MultiSelectFieldSortBy = {}));
const toNumber = (value) => {
    const numberString = (value || '')
        .split('')
        .filter((c) => c.match(/[.0-9]/g))
        .join('');
    return parseFloat(numberString);
};
const applyOrder = (children, orderedChildren) => {
    return orderedChildren
        .map((child) => children.find((c) => c.props.value === child.props.value))
        .filter((c) => c);
};
export class MultiSelectField extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            orderedChildren: [],
            searchTerm: '',
        };
        this.sortWith = (getter, sortType) => (c1, c2) => {
            const value1 = getter(c1);
            const value2 = getter(c2);
            if (sortType === 'number') {
                const number1 = toNumber(String(value1));
                const number2 = toNumber(String(value2));
                return isNaN(number1) || number1 > number2 ? 1 : -1;
            }
            else if (sortType === 'boolean') {
                return value1 > value2 ? 1 : -1;
            }
            return (value1 || '').localeCompare(value2 || '');
        };
        this.sortChildren = () => {
            const { sortMode } = this.state;
            if (!sortMode) {
                return this.state.orderedChildren;
            }
            const orderedChildren = [...this.state.orderedChildren];
            if (sortMode.by === MultiSelectFieldSortBy.label) {
                orderedChildren.sort(this.sortWith((c) => c.props.label, 
                // @ts-ignore
                sortMode.type));
            }
            else if (sortMode.by === MultiSelectFieldSortBy.rightLabel) {
                orderedChildren.sort(this.sortWith(
                // @ts-ignore
                (c) => c.props.rightLabel, sortMode.type));
            }
            if (sortMode.isReverseSort) {
                orderedChildren.reverse();
            }
            return orderedChildren;
        };
    }
    static getDerivedStateFromProps(props, state) {
        // Only reorder children on mount and when the child options have changed.
        // We don't want to reorder as the user selects items.
        const shouldSortChildren = hasMissingChildValue(state.orderedChildren, 
        // @ts-ignore
        props.children);
        if (shouldSortChildren) {
            return {
                // @ts-ignore
                orderedChildren: sortChildrenBySelected(props.value, props.children),
            };
        }
        else {
            return {
                // @ts-ignore
                orderedChildren: applyOrder(props.children, state.orderedChildren),
            };
        }
    }
    render() {
        const { label, value, onChange, selectable, disabled, searchable, helperText, error, classes, onBlur, sortable, } = this.props;
        const { searchTerm } = this.state;
        let orderedChildren = this.sortChildren();
        if (searchable && searchTerm) {
            orderedChildren = orderedChildren.filter((child) => (child.props.label || '')
                .toLowerCase()
                .includes(searchTerm.toLowerCase()));
        }
        return (_jsxs("div", Object.assign({ className: classes.root, onBlur: onBlur }, { children: [_jsx(InputLabel, Object.assign({ error: error }, { children: label })), _jsxs("div", Object.assign({ className: cn(classes.contentWrapper, {
                        [classes.withSearch]: searchable,
                    }) }, { children: [searchable && (_jsx(MultiSelectFieldSearchBox, { value: value, options: orderedChildren, searchTerm: searchTerm, disabled: disabled, sortable: sortable, onChange: onChange, onSearchChange: (newSearchTerm) => this.setState({ searchTerm: newSearchTerm }), onSortChange: (newSortMode) => this.setState({ sortMode: newSortMode }) })), _jsx("div", Object.assign({ className: cn(classes.items, disabled && classes.disabled) }, { children: orderedChildren.map((child) => {
                                const isOptionSelected = isElementSelected(value, child);
                                const optionValue = child.props.value;
                                return React.cloneElement(child, {
                                    disabled,
                                    selectable,
                                    checked: isOptionSelected,
                                    onClick: () => {
                                        if (isOptionSelected) {
                                            onChange(value.filter((item) => item !== optionValue));
                                        }
                                        else {
                                            onChange([...value, optionValue]);
                                        }
                                    },
                                });
                            }) }))] })), _jsx(InputHelperText, Object.assign({ error: error }, { children: helperText }))] })));
    }
}
MultiSelectField.defaultProps = {
    disabled: false,
    searchable: false,
    error: false,
    helperText: '',
    children: [],
    sortable: [],
};
export default Object.assign(withStyles(styles)(MultiSelectField), {
    Option: MultiSelectFieldOption,
});
//# sourceMappingURL=MultiSelectField.js.map